import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Person, Headset, Columns, ChatLeft, House, ArrowBarLeft, ArrowBarRight, BoxArrowRight } from 'react-bootstrap-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { useSidebar } from '../contexts/SidebarContext';
import './Sidebar.css';

const Sidebar: React.FC = () => {
  const { isCollapsed, toggleSidebar } = useSidebar();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/signin');
    } catch (error) {
      console.error('Failed to logout:', error);
    }
  };

  const renderNavItem = (to: string, icon: React.ReactNode | null, text: string, onClick?: () => void, isFooterItem: boolean = false) => {
    const isActive = to && location.pathname === to;

    const linkContent = (
      <Link to={to} className={`sidebar-link ${isActive ? 'active' : ''}`} onClick={onClick}>
        {icon && (!isFooterItem || isCollapsed) && icon}
        {!isCollapsed && <span className="sidebar-text">{text}</span>}
      </Link>
    );

    if (isCollapsed && icon) {
      return (
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id={`tooltip-${text}`}>{text}</Tooltip>}
        >
          <div>{linkContent}</div>
        </OverlayTrigger>
      );
    }

    return linkContent;
  };

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <button
        className="sidebar-toggle"
        onClick={toggleSidebar}
        aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        {isCollapsed ? <ArrowBarRight /> : <ArrowBarLeft />}
      </button>
      
      <div className="sidebar-content">
        <nav>
          <ul className="sidebar-nav">
            <li>
              {renderNavItem("/home", <House className="sidebar-icon" />, "Home")}
            </li>
            <li>
              {renderNavItem("/projects", <Columns className="sidebar-icon" />, "Projects")}
            </li>
            <li>
              {renderNavItem("/chat-history", <ChatLeft className="sidebar-icon" />, "Conversations")}
            </li>
          </ul>
        </nav>

        <div className="sidebar-footer">
          <ul className="sidebar-nav">
            <li>
              {renderNavItem("/dashboard", <Person className="sidebar-icon" />, "Profile & Settings", undefined, true)}
            </li>
            <li>
              {renderNavItem("/help", <Headset className="sidebar-icon" />, "Help", undefined, true)}
            </li>
            <li>
              {renderNavItem("", <BoxArrowRight className="sidebar-icon" />, "Logout →", handleLogout, true)}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;